export default function ControllingGroupBottom(){
    return(
        <>
        <h4>Controlling Group Bottom</h4>
        </>
    )
}

// import { Box, Breadcrumbs, Card, CardContent, CardMedia, Container, CssBaseline, Grid, Link, Paper, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
// import React, { useContext, useEffect, useState } from 'react'
// import { Nav, Tab, Tabs } from 'react-bootstrap';
// import { useLocation, NavLink, useNavigate, useNavigation, useRoutes } from 'react-router-dom';

// import { InverterContext } from '../../../../../../context/InverterContext';
// import { getDateTimeForPvParameter, getFormattedDateTimeForHYBRD } from '../../../../../../utils';

// import ControllingGroup from '../../../../page/inverter/tabs_content/ControllingGroup';


// export default function ControllingGroupBottom() {
//     const { palette, spacing, typography, breakpoints, shape: { } } = useTheme()
//     const { getHYBRD, POST_KWH_HYBRID_DATA, getPostKwhHybrid, HYBRD_DATA, HYBRD_LOADING } = useContext(InverterContext)
//     const [DT1, setDT1] = useState(getDateTimeForPvParameter().LastDay)
//     const [DT2, setDT2] = useState(getDateTimeForPvParameter().Today)
//     const matches = useMediaQuery(breakpoints.up('lg'));
//     const LOGIN_ID = localStorage.getItem('LoginID')
//     const LOC_CODE = localStorage.getItem('LCODE')
//     const location = useLocation();
//     const PASS_KEY = "XXXXXXXXXXXX"
//     const PASS_KEY1 = "xyz"
//     const WEB_KEY1 = "WEBXYZ321"
//     const WEB_KEY = "WEBXYZABC"
//     const IROW = 1
//     const TYP1 = "C"
//     const [TYP, setTYP] = useState('D');

//     // useEffect(() => {
//     //     getPostKwhHybrid(LOGIN_ID, LOC_CODE, PASS_KEY1, WEB_KEY1, TYP1, DT1, DT2)
//     // }, [LOC_CODE])

//     useEffect(() => {
//         getHYBRD(LOGIN_ID, LOC_CODE, PASS_KEY, WEB_KEY, TYP, IROW, DT1, DT2)
//     }, [TYP])

  

//     return (
//        <>
//         <div className='row'>
//             <div className='col-md-12'>
//             <ControllingGroup data={HYBRD_DATA} />
//             </div>
//         </div>
//        </>

//     )
// }